"use strict";
// (C) 2019-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateGranularity = void 0;
/**
 * Defines shortcuts for commonly used date dataset attribute granularities.
 *
 * @public
 */
exports.DateGranularity = {
    date: "GDC.time.date",
    week: "GDC.time.week_us",
    month: "GDC.time.month",
    quarter: "GDC.time.quarter",
    year: "GDC.time.year",
};
//# sourceMappingURL=dateGranularities.js.map